export default import.meta.ROLLDOWN_FILE_URL_rY1n9knddGqehhNPLmcULg